import { Home } from "styled-icons/boxicons-solid/Home"
import { SearchAlt2 as Search } from "styled-icons/boxicons-regular/SearchAlt2"
import { UpArrowAlt as Arrow } from "styled-icons/boxicons-regular/UpArrowAlt"
import { Lightbulb as Light } from "styled-icons/fa-regular/Lightbulb"
import { Lightbulb as LightSolid } from "styled-icons/fa-solid/Lightbulb"
import { Grid } from "styled-icons/boxicons-solid/Grid"
import { ListUl as List } from "styled-icons/boxicons-regular/ListUl"

const Icons = {
  Home,
  Search,
  Arrow,
  Light,
  LightSolid,
  Grid,
  List,
}

export default Icons
